import { makeAutoObservable } from 'mobx'
import { type IDropdownItem } from 'shared/ui'
import { LINK_HELP_GET_A_BUSINESS_TAX_ID } from 'shared/constants/links'
import { ICountriesEnum } from 'entities/Compliance'

export type RegistrationAuthorityConfig = {
  countries: IDropdownItem[]
}

export class RegistrationAuthoritySelectStore {
  private _country: ICountriesEnum | null = null
  private readonly _config: RegistrationAuthorityConfig

  constructor(config: RegistrationAuthorityConfig) {
    this._config = config
    makeAutoObservable(this)
  }

  getCountryKey = (key: string) => {
    switch (key) {
      case 'UK:CRN':
        return ICountriesEnum.GB
      case 'US:EIN':
        return ICountriesEnum.US
      case 'CA:CBN':
        return ICountriesEnum.CA
      case 'AU:ACN':
        return ICountriesEnum.AU
      case 'OTHER':
        return ICountriesEnum.OTHER
      default:
        return null
    }
  }

  get countries(): IDropdownItem[] {
    return this._config.countries
  }

  get isDontHaveBusinessTaxID() {
    return this._country === ICountriesEnum.OTHER
  }

  get isUSLocation() {
    return this._country === ICountriesEnum.US
  }

  get isCALocation() {
    return this._country === ICountriesEnum.CA
  }

  get isLocationEmpty() {
    return this._country === null
  }

  get businessTaxIDLink() {
    return LINK_HELP_GET_A_BUSINESS_TAX_ID
  }

  get country() {
    return this._country
  }

  get countryData() {
    const current = this.countries.find((country) => country.id === this._country)

    if (!current) return null

    return {
      flag: current?.iconL,
      name: current?.label,
      iconColor: this._country === ICountriesEnum.OTHER ? 'var(--gray-60)' : undefined,
    }
  }

  setCountry = (country: ICountriesEnum) => {
    this._country = country
  }

  setCountryByKey = (key: string) => {
    this._country = this.getCountryKey(key)
  }
}
